import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const SidebarFooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

export default SidebarFooterText;
